(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tab"] && !Shopify.designMode) return;
  try {
    
  class PivotProductDescription extends HTMLElement {
    constructor() {
      super();
      this.$triggersWrapper = this.querySelector('.pivot-product-description__tabs');
      this.$$triggers = this.$triggersWrapper.querySelectorAll('button');
      this.$contentsWrapper = this.querySelector('.pivot-product-description__contents');

      this.$$triggers.forEach((button) => {
        button.addEventListener('click', (e) => {
          const currentActive = this.$triggersWrapper.querySelector('button.active');
          if (currentActive) currentActive.classList.remove('active');
          button.classList.add('active');

          const currentSectionActive = this.$contentsWrapper.querySelector('details[open]');
          if (currentSectionActive) currentSectionActive.open = false;

          const selector = `details[data-link="${button.dataset.link}"]`;
          const newSectionActive = this.$contentsWrapper.querySelector(selector);
          if (newSectionActive) newSectionActive.open = true;
        });
      });
    }
  }
  if (!customElements.get('pivot-product-description')) {
    customElements.define('pivot-product-description', PivotProductDescription);
  }

  } catch(e) { console.error(e); }
})();
})();
